import { Account } from '@/client/accounts';
import { Integrations } from '@/client/accounts/types/account-user-management.type';
import {
  OperationLog,
  OperationLogSource,
  OperationLogStatus,
} from '@/client/operation-log';
import { getAccountIntegration } from './account.helper';

export const hasCurrentOperationLogErrors = (
  log: OperationLog | undefined,
  account?: Account | null,
): boolean => {
  if (
    !log ||
    log.status === OperationLogStatus.SUCCESS ||
    log.errorCount <= 0
  ) {
    return false;
  }

  if (log.source === OperationLogSource.AD_SYNC) {
    return (
      getAccountIntegration(account)?.source === Integrations.ACTIVE_DIRECTORY
    );
  }

  if (log.source === OperationLogSource.GOOGLE_WORKSPACE_SYNC) {
    return (
      getAccountIntegration(account)?.source === Integrations.GOOGLE_WORKSPACE
    );
  }

  return true;
};

export const countCurrentOperationLogErrors = (
  logs: OperationLog[] | undefined,
  account?: Account | null,
): number =>
  logs
    ?.filter((log) => hasCurrentOperationLogErrors(log, account))
    .reduce((sum, log) => sum + log.errorCount, 0) ?? 0;
